import { render } from "./AILoadingMessage.vue?vue&type=template&id=4e633972&scoped=true"
import script from "./AILoadingMessage.vue?vue&type=script&lang=js"
export * from "./AILoadingMessage.vue?vue&type=script&lang=js"

import "./AILoadingMessage.vue?vue&type=style&index=0&id=4e633972&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e633972"]])

export default __exports__